<template>
<div>
  <div class="tab-box">
    <!--信用额度记录-->
    <el-row>
      <el-form :inline="true" :model="creditForm" class="demo-form-inline">
        <el-form-item label="时间">
          <el-date-picker
            v-model="time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="handleTime"
            style="width:220px"
            size="small"
            :clearable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="类型">
          <el-select  size="small" v-model="creditForm.changeType" clearable placeholder="请选择" @change="handleChangechangeType">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-row>
    <Table
      :props="table.props"
      :header="table.header"
      :data="table.data"
      v-loading="loading"
    />
    <pagination
      v-bind:currentpage="currentPage"
      v-bind:pagesize="pageSize"
      v-bind:totalcount="totalCount"
      @handle-size-change="handleSizeChange"
      @handle-current-change="handleCurrentChange"
    ></pagination>
  </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      creditForm: {
        startDateX: '',
        endDateX: '',
        changeType: '',
        pageNo: 1,
        pageSize: 10
      },
      time: this.getTime(),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6
        }
      },
      pageSize: 10,
      // 当前页码:pageNum
      currentPage: 1,
      totalCount: 0,
      loading: false,
      table: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '交易流水号',
            align: 'left',
            prop: 'changeNo',
            'show-overflow-tooltip': true,
            'min-width': '220/1360'
          },
          {
            label: '时间',
            align: 'left',
            prop: 'changeTime',
            'show-overflow-tooltip': true,
            'min-width': '220/1360',
            formatter: params => {
              return this.$moment(params.changeTime).format('YYYY-MM-DD HH:mm:ss')
            }
          },
          {
            label: '调整额度',
            align: 'right',
            prop: 'changeCredit',
            'show-overflow-tooltip': true,
            'min-width': '120/1360',
            formatter: params => {
              if (params.changeCredit > 0) {
                return '+' + this.$consts.toLocaleString(params.changeCredit || 0)
              } else {
                return this.$consts.toLocaleString(params.changeCredit || 0)
              }
            }

          },
          {
            label: '类型',
            align: 'left',
            prop: 'changeType',
            'show-overflow-tooltip': true,
            'min-width': '80/1360',
            formatter: params => {
              return this.$consts.financialCreditText[params.changeType]
            }
          },
          {
            label: '固定信用额度',
            align: 'right',
            prop: 'fixedCredit',
            'show-overflow-tooltip': true,
            'min-width': '140/1360',
            formatter: params => {
              return this.$consts.toLocaleString(params.fixedCredit || 0)
            }
          },
          {
            label: '临时信用额度',
            align: 'right',
            prop: 'tempCredit',
            'show-overflow-tooltip': true,
            'min-width': '140/1360',
            formatter: params => {
              return this.$consts.toLocaleString(params.tempCredit || 0)
            }
          },
          {
            label: '总信用额度',
            align: 'right',
            'show-overflow-tooltip': true,
            'min-width': '140/1360',
            formatter: params => {
              const total = parseFloat(params.fixedCredit || 0) + parseFloat(params.tempCredit || 0)
              return this.$consts.toLocaleString(total)
            }
          },
          {
            label: '备注',
            align: 'left',
            prop: 'remark',
            'show-overflow-tooltip': true,
            'min-width': '270/1360'
          }
        ],
        data: []
      },
      options: this.$consts.financialCreditOptions
    }
  },
  methods: {
    getTime() {
      const timestamp = new Date().getTime()
      const newDate = new Date(timestamp - 6 * 24 * 3600 * 1000)
      return [newDate, new Date()]
    },
    handleTime(val) {
      this.getCreditPageList()
    },
    handleChangechangeType() {
      this.getCreditPageList()
    },
    getCreditPageList() {
      this.loading = true
      this.creditForm.pageNo = this.currentPage
      this.creditForm.pageSize = this.pageSize
      if (this.time.length > 0) {
        this.creditForm.startDateX = this.$moment(this.time[0]).format('YYYY-MM-DD 00:00:00')
        this.creditForm.endDateX = this.$moment(this.time[1]).format('YYYY-MM-DD 23:59:59')
      } else {
        this.creditForm.startDateX = undefined
        this.creditForm.endDateX = undefined
      }
      this.$service.getCreditPageList(this.creditForm).then(data => {
        this.table.data = data.rows || []
        this.totalCount = data.total || 0
        this.loading = false
      })
    },
    // 每页显示数据量变更, 如每页显示10条变成每页显示20时,val=20
    handleSizeChange: function (val) {
      this.pageSize = val
      this.getCreditPageList()
    },
    // 页码变更, 如第1页变成第2页时,val=2
    handleCurrentChange: function (val) {
      this.currentPage = val
      this.getCreditPageList()
    }
  },
  created() {
    this.getCreditPageList()
  }
}
</script>
<style lang="stylus" scoped>
.tab-box {
  margin: 0px 16px;
  padding: 24px 25px;
  background-color: #fff;
  border-radius 2px
}
</style>
